module.exports = __webpack_public_path__ + "media/images/photo/plans/places/osaka_castle_park-580d60bb112a7edd962cebfb08caae2d.png";